import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import clientService from '../../services/ClientService';
import { useDispatch } from 'react-redux';



export const initialState = {
	loading: false,
	message: '',
	list:null,
}



export const companyListAll = createAsyncThunk('company/list',async (data, { rejectWithValue }) => {
	
	try {
		const response = await clientService.getCompany()
		return response.data;
		
		
	} catch (err) {
		
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})


export const companySlice = createSlice({
	name: 'company',
	initialState,
	reducers: {
			
		companyList: (state, action) => {
			state.loading = true
			state.list = action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(companyListAll.pending, (state) => {
		
				state.loading = false
			})
			.addCase(companyListAll.fulfilled, (state, action) => {
				state.loading = true
				state.list = action.payload
			})
			
	},
})

export const { 
	companyList,
    
    
} = companySlice.actions

export default companySlice.reducer